import Swal from 'sweetalert2';

// Function to show the choice modal for printing or downloading
const showPrintOption = (downloadUrl, id, token, fileName) => {
    Swal.fire({
        title: 'Choose an Option',
        text: 'Do you want to download the PDF or print it immediately?',
        icon: 'question',
        showCancelButton: true,
        showDenyButton: true,
        confirmButtonColor: "#a4eeb6",
        denyButtonColor: "#88b5e4",
        cancelButtonColor: "#acb9c4",
        confirmButtonText: 'Print',
        denyButtonText: 'Download',
        cancelButtonText: 'Cancel',
        customClass: {
            popup: 'swal-custom-font'
        }
    }).then((result) => {
        if (result.isConfirmed) {
            fetchAndPrint(downloadUrl, id, token, fileName);
        } else if (result.isDenied) {
            fetchAndDownload(downloadUrl, id, token, fileName);
        }
    });
};

const fetchAndPrint = (downloadUrl, id, token) => {
    Swal.fire({
        title: 'Print in Progress',
        text: 'Please wait while the PDF is being generated and processed. This may take a while if some images or files are attached.',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showCancelButton: false,
        showConfirmButton: false,
        didOpen: () => {
            Swal.showLoading();
        },
    });

    fetch(downloadUrl, { headers: {
            'Authorization': token,
        }
    })
        .then((response) => response.blob())
        .then((blob) => {
            const blobUrl = URL.createObjectURL(blob);
            const printWindow = window.open(blobUrl);

            if (printWindow) {
                // Wait for the window to load, then print
                printWindow.onload = function () {
                    Swal.close();
                    printWindow.print();
                    URL.revokeObjectURL(blobUrl);
                };
            } else {
                // Fallback to download if pop-up is blocked
                fallbackToDownload(blobUrl, id);
            }
        })
        .catch((error) => {
            console.error('Error generating or printing the PDF:', error);
            Swal.fire('Error', 'Failed to generate or print the PDF', 'error');
        });
};

const fetchAndDownload = (downloadUrl, id, token, fileName) => {
    Swal.fire({
        title: 'Download in Progress',
        text: 'Please wait while the PDF is being generated.',
        allowOutsideClick: false,
        allowEscapeKey: false,
        showCancelButton: false,
        showConfirmButton: false,
        didOpen: () => {
            Swal.showLoading();
        },
    });

    fetch(downloadUrl,{ headers: {
        'Authorization': token,
    }
    })
        .then((response) => response.blob())
        .then((blob) => {
            const blobUrl = URL.createObjectURL(blob);
            downloadFile(blobUrl, `${fileName}-${id}.pdf`);
            Swal.close();
            Swal.fire({
                icon: 'success',
                title: 'Download Complete',
                text: 'The PDF has been downloaded successfully.',
            });
        })
        .catch((error) => {
            console.error('Error generating the PDF:', error);
            Swal.fire('Error', 'Failed to generate or download the PDF', 'error');
        });
};

const fallbackToDownload = (blobUrl, id, fileName) => {
    Swal.close();
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = `${fileName}-${id}.pdf`;
    link.click();
    URL.revokeObjectURL(blobUrl);
    Swal.fire('Notice', 'Pop-up was blocked. The PDF was downloaded instead.', 'info');
};

const downloadFile = (blobUrl, fileName) => {
    const link = document.createElement('a');
    link.href = blobUrl;
    link.download = fileName;
    link.click();
    URL.revokeObjectURL(blobUrl);
};

// Function to handle the keyboard shortcut for printing
const handleKeydown = (event, downloadUrl, id, token, fileName) => {
    if ((event.ctrlKey || event.metaKey) && event.key.toLowerCase() === 'p') {
        event.preventDefault(); // Prevent the default print dialog
        showPrintOption(downloadUrl, id, token, fileName);
    }
};

const PrintUtil = {
    showPrintOption,
    handleKeydown
};

export default PrintUtil;
